import { render, staticRenderFns } from "./detail-button.vue?vue&type=template&id=5b4e69b6&"
import script from "./detail-button.vue?vue&type=script&lang=ts&"
export * from "./detail-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b4e69b6')) {
      api.createRecord('5b4e69b6', component.options)
    } else {
      api.reload('5b4e69b6', component.options)
    }
    module.hot.accept("./detail-button.vue?vue&type=template&id=5b4e69b6&", function () {
      api.rerender('5b4e69b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/matrix-actions/detail-button/detail-button.vue"
export default component.exports